import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-erreurs',
  templateUrl: './erreurs.component.html',
  styleUrls: ['./erreurs.component.css']
})
export class ErreursComponent implements OnInit, OnChanges {

  @Input('error-list') errors : SelectItem[];
  @Input('selected-errors') selectedErrors : Object[] = [];

  @Input('cq') cq: boolean = false;

  @Output() errorsChangedEvent = new EventEmitter<Object[]>();

  constructor() { 
    
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
      if(changes && changes.selectedErrors) {
        this.convertIdMotif(changes.selectedErrors.currentValue); //=> on convertit l'id_motif pour être sûr du format
        this.selectedErrors = changes.selectedErrors.currentValue;
      }
  }

  errorChanged(value: Object[]){
    this.errorsChangedEvent.emit(value);
  }

  convertIdMotif(value: any) {
    value.map(element => {
       element.id_motif = parseInt(element.id_motif);
    });
  }



  

}
